import Vue from 'vue';

Vue.mixin({
  data() {
    return {
      outerWidth: window.outerWidth,
      outerHeight: window.outerHeight,
      imgSize: {
        'mini': '?x-image-process=image/resize,m_lfit,h_50,w_50',
        'small': '?x-image-process=image/resize,m_lfit,h_100,w_100',
        'icon': '?x-image-process=image/resize,m_lfit,h_200,w_200',
        'list': '?x-image-process=image/resize,m_lfit,h_300,w_300',
        'middle': '?x-image-process=image/resize,m_lfit,w_800',
        'hd': '?x-image-process=image/resize,m_lfit,w_1600'
      },
    };
  },
  methods: {},
  mounted() {

  }
});
